module.exports = __webpack_public_path__ + "img/404.61d6025e.svg";